import {
  Component,
  ViewEncapsulation,
  OnInit,
  ViewChild,
  ElementRef,
  AfterViewInit,
} from '@angular/core';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { KYMW4402Model } from './kymw4402.model';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { FlexGrid, CellType } from '@grapecity/wijmo.grid';
import { PlessAlert } from 'src/app/shared/pless-alert/pless-alert.component';
import { EventArgs } from '@grapecity/wijmo';
import { KYMW4402InputModel } from './vo/kymw4402-input.model';
import { GetCoopListService } from './api-services/get-coop-list.service';
import { CopyPageInfoToCoopsService } from './api-services/copy-page-info-to-coops.service';
import { GetMediumListService } from '../../../commons/kymw02/api-services/get-medium-list.service';

/**
 * 生協間コピー設定を管理するクラス
 *
 * @export KYMW4402Component
 * @class KYMW4402Component
 */
@Component({
  selector: 'app-kymw4402',
  templateUrl: 'kymw4402.component.html',
  styleUrls: ['kymw4402.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class KYMW4402Component
  extends PlessViewHelperSub
  implements OnInit, AfterViewInit
{
  @ViewChild('dtg_CoopList', { static: false }) dtg_CoopList: FlexGrid;
  @ViewChild('btn_Set', { static: false }) btn_Set: ElementRef;

  public model: KYMW4402Model = new KYMW4402Model();

  private validations: {
    invalid: (m: KYMW4402Model) => boolean;
    code: string;
    messages: string[];
  }[] = [
    {
      invalid: m => !m.copyCoopList.find(_ => _.check),
      code: 'E0103',
      messages: ['会員生協'],
    },
  ];

  /**
   * Creates an instance of KYMW4402Component.
   *
   * @param {PlessDialogServiceSub} dialogService
   * @param {GetCoopListService} getCoopListService
   * @param {GetMediumListService} getMediumListService
   * @param {CopyPageInfoToCoopsService} copyPageInfoToCoopsService
   * @param {KYMW00Model} kymw00Model
   * @memberof KYMW4402Component
   */
  constructor(
    private dialogService: PlessDialogServiceSub,
    private getCoopListService: GetCoopListService,
    private getMediumListService: GetMediumListService,
    private copyPageInfoToCoopsService: CopyPageInfoToCoopsService,
    private kymw00Model: KYMW00Model
  ) {
    super(kymw00Model);
  }

  /**
   * コンポーネント初期化
   *
   * @memberof KYMW4402Component
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW4402';
    this.getCoopListService.execute(this.model);
    this.getMediumListService.execute(null, this.model, 'mediumList');
  }

  /**
   * ビュー初期化
   *
   * @memberof KYMW4402Component
   */
  public ngAfterViewInit(): void {
    this.dtg_CoopList.itemsSourceChanged.addHandler(
      (_g: FlexGrid, _e: EventArgs) => {
        _g.select(-1, -1);
      }
    );
    this.dtg_CoopList.hostElement.addEventListener('click', e => {
      const ht = this.dtg_CoopList.hitTest(e.pageX, e.pageY);
      if (ht.cellType === CellType.Cell && ht.col === 0) {
        const val = this.dtg_CoopList.getCellData(ht.row, ht.col, false);
        this.dtg_CoopList.setCellData(ht.row, ht.col, val ? false : true);
      }
    });
    // 非活性制御
    this.dtg_CoopList.itemFormatter = (panel, r, c, cell) => {
      if (panel.cellType === CellType.Cell) {
        const id = this.dtg_CoopList.getCellData(r, 1, false);
        if (id === this.model.coopCode) {
          cell.className += ' disabled-row';
        }
        if (id === this.model.coopCode && c === 0) {
          cell.childNodes.forEach(_ => cell.removeChild(_));
          cell.innerHTML = '<input type="checkbox" disabled />';
        }
      }
    };
  }

  /**
   * グリッド初期処理
   *
   * @memberof KYMW4400Component
   */
  public gridInit(grid: FlexGrid) {
    grid.select(-1, -1);
  }

  /**
   * ボタン押下 設定
   *
   * @memberof KYMW4402Component
   */
  public set() {
    // バリデーション
    const vali = this.validations.find(_ => _.invalid(this.model));
    if (vali) {
      this.dialogService.openAlertGetMessage(vali.code, vali.messages);
      return;
    }
    // ダイアログ・APIリクエスト
    this.dialogService.openAlertGetMessage('Q0170', [], _e => {
      if (_e === PlessAlert.Yes) {
        this.copyPageInfoToCoopsService.execute(this.model, () =>
          this.closeFunction()
        );
      }
    });
  }

  /**
   * 呼び出し側から利用
   *
   */
  setParams(data: KYMW4402InputModel) {
    this.model.mediumType = data.mediumType;
    this.model.orderCode = data.orderCode;
    this.model.catalogId = data.catalogId;
    this.model.coopCode = data.coopCode;
  }
}
